import React, { useCallback } from 'react';

// ENUMS
import { InputType } from '../../enums/inputType';

// INTERFACES
import { ICardSelect } from '../../interfaces/CardSelect.interface';

import {
  CardSelectDescriptionStyled,
  CardSelectHeaderStyled,
  CardSelectIconContainerStyled,
  CardSelectInputContainerStyled,
  CardSelectInputStyled,
  CardSelectStyled,
  CardSelectTitleStyled,
  CardSelectContent
} from './styles';

const CardSelect: React.FC<ICardSelect> = ({
  checked,
  description,
  icon: Icon,
  id,
  name,
  onChange,
  title,
  type = InputType.RADIO,
  value,
  disabled
}) => {
  const handleClick = useCallback(
    (value, name) => {
      if (!disabled) {
        onChange(value, name);
      }
    },
    [onChange]
  );

  return (
    <CardSelectStyled id={id} onClick={() => handleClick(value, name)} checked={checked} disabled={disabled}>
      <CardSelectIconContainerStyled>
        <Icon />
      </CardSelectIconContainerStyled>
      <CardSelectContent>
        <CardSelectTitleStyled>{title}</CardSelectTitleStyled>
        <CardSelectDescriptionStyled>{description}</CardSelectDescriptionStyled>
      </CardSelectContent>
      <CardSelectHeaderStyled checked={checked} disabled={disabled} />
      <CardSelectInputContainerStyled>
        {checked && <CardSelectInputStyled type={type} name={name} value={value} checked={checked} readOnly />}
      </CardSelectInputContainerStyled>
    </CardSelectStyled>
  );
};

export default CardSelect;
